import {
    UsersListsContextDispatchMessage,
    UsersListsContextDispatchMessageType,
    UsersListsContextState
} from "./UsersListsContext.interfaces";
import {MailingList} from "../../Interfaces/MailingList";

export const initialState: UsersListsContextState = {
    loaded: false,
    lists: new Array<MailingList>(),
}

export const reducer = (prevState: UsersListsContextState, payloads: Array<UsersListsContextDispatchMessage>): UsersListsContextState => {
    const newState: UsersListsContextState = {...prevState};
    payloads.forEach(payload => {
        const payloadType = payload.type;
        switch (payloadType) {
            case UsersListsContextDispatchMessageType.SetLists:
                newState.lists = payload.lists;
                break;
            case UsersListsContextDispatchMessageType.SetLoaded:
                newState.loaded = payload.value;
                break;
            case UsersListsContextDispatchMessageType.AddUpdateUsersList:
                newState.lists = [...newState.lists];
                newState.lists = newState.lists.filter(t => t.id !== payload.list.id);
                newState.lists.push(payload.list);
                break;
            case UsersListsContextDispatchMessageType.DeleteUsersList:
                newState.lists = [...newState.lists];
                newState.lists = newState.lists.filter(t => t.id !== payload.id);
                break;
            default:
                throw new Error("Message " + UsersListsContextDispatchMessageType[payloadType] + " not implemented");
        }
    });
    return newState;
}